module.exports = __webpack_public_path__ + "img/12124058.30114b15.png";